import React from 'react';
import '../pages/BayilikBasvuruPublicPage.css';

export function BayilikBasvuruHeader({ title = 'Bayi Sistem Kayıt Formu' }) {
  return (
    <header className="bayilik-basvuru-header">
      <div className="bayilik-basvuru-header-bg" aria-hidden="true" />
      <div className="bayilik-basvuru-header-inner">
        <div className="bayilik-basvuru-logo-wrap">
          <img src="/assets/img/logo.png" alt="Ünmak" className="bayilik-basvuru-logo" />
        </div>
        <h1>{title}</h1>
      </div>
    </header>
  );
}

export default function BayilikBasvuruShell({ children, title }) {
  return (
    <div className="bayilik-basvuru-page">
      <div className="bayilik-basvuru-card">
        <BayilikBasvuruHeader title={title} />
        <div className="bayilik-basvuru-body">{children}</div>
      </div>
    </div>
  );
}
